// Utility layer (TS-2.5.04) - pure, no side effects. Resolves a colour that travels either as a
// brand token NAME or as a frozen literal hex, per decisions.md D-196: "the leading '#' says
// which". applyBrandingTokens (theme/applyBrandingTokens.ts) has already written every
// BrandingTokens entry onto the document as `--eg-color-{name}` custom properties by the time a
// component renders (useRoadmap calls it as soon as a RoadmapView arrives), so a token NAME
// resolves through the CSS custom property and repaints live if an admin re-saves branding; a
// literal hex (BoardChip.colorHex, StatusView.colorHex, MilestoneView.completionColorHex - all
// already-resolved reference-data colours per decomposition.md section 8.7 point 6) is returned
// unchanged. No component in this feature reads a hex literal by name (decomposition.md 6.2).
export function resolveColor(token: string): string {
  return token.startsWith("#") ? token : `var(--eg-color-${token})`;
}
